import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState(['users'])
    },
    
    mounted() {
        if(!this.users.length) {
            this.$store.dispatch('fetchUsers');
        }
    }

}